// extracted by mini-css-extract-plugin
module.exports = {"bargain":"_1Gydxb0WKb","form-item":"_3O32-MR9aJ","button-margin":"fbvLTpYhZb","table-main":"_3n3cgGl-kX","ware":"jlqoe0sd08","ware-info":"MNUM8IppN0"};